import { styled } from 'styled-components';

export const ReportsContainer = styled.div`
  width: 100%;
  height: 80vh; /* Adjust height as needed */
  display: flex;
  justify-content: center;
  align-items: center;
`;
